'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardHeaderSecondaryTextStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  size: _propTypes2.default.oneOf(['default', 'medium', 'large', 'xlarge']),
  theme: _propTypes2.default.object
};
var defaultProps = {
  size: 'default'
};
/** Prop Receivers */

var fontProps = function fontProps(_ref) {
  var themeFromProvider = _ref.theme,
      size = _ref.size;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com = theme.reactackle.components.card.headerSecondary.size[size],
      fontSize = _theme$reactackle$com.fontSize,
      lineHeight = _theme$reactackle$com.lineHeight,
      fontColor = _theme$reactackle$com.fontColor,
      fontWeight = _theme$reactackle$com.fontWeight;
  return '\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    line-height: ' + lineHeight + ';\n    color: ' + fontColor + ';\n    font-weight: ' + fontWeight + ';\n  ';
};
/** Styles */


var CardHeaderSecondaryTextStyled = exports.CardHeaderSecondaryTextStyled = _styledComponents2.default.div.withConfig({
  displayName: 'CardHeaderSecondaryTextStyled'
})(['margin:0;', ';'], fontProps);

CardHeaderSecondaryTextStyled.propTypes = propTypes;
CardHeaderSecondaryTextStyled.defaultProps = defaultProps;
CardHeaderSecondaryTextStyled.displayName = 'CardHeaderSecondaryTextStyled';